"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _immutable = require("immutable");

var WorkspaceMember =
/*#__PURE__*/
function (_Record) {
  (0, _inherits2.default)(WorkspaceMember, _Record);

  function WorkspaceMember(props) {
    (0, _classCallCheck2.default)(this, WorkspaceMember);

    if (props) {
      props.memberKey = props.memberType + "_" + props.id;
    }

    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(WorkspaceMember).call(this, props));
  }

  return WorkspaceMember;
}((0, _immutable.Record)({
  id: undefined,
  memberType: '',
  name: '',
  usersCount: 1,
  memberKey: ''
}, 'WorkspaceMember'));

var _default = WorkspaceMember;
exports.default = _default;
module.exports = exports.default;